import React from 'react'
import './testimonial.scss'
import TestimonialOne from '../../../../assets/Testimonial_1.png'
import TestimonialTwo from '../../../../assets/Testimonial_2.png'
import TestimonialThree from '../../../../assets/Testimonial_3.png'
import TestimonialFour from '../../../../assets/Testimonial_4.png'

const Testimonial = () => {
  const testimonials = [
    {
      name: 'D. Russel',
      testimony:
        '“The answering services is super great, I can clearly say that it is one of my best investments since starting my business. You guys make me look and sound professional to other colleagues. I often receive excellent reviews from my clients about my courteous staff members. Things are going very well. Please keep exceeding my expectations.”',
      image: TestimonialOne,
    },
    {
      name: 'A. Walker',
      testimony:
        '“I have been a client of Virtual Enterprise for over two years. I currently have a Trinidad, Jamaica and a Local Miami number that are all directed to the answering service. I am pleased with the level of service provided as I often receive compliments from my clients based on the knowledge displayed about my services.”',
      image: TestimonialTwo,
    },
    {
      name: 'S. Murray',
      testimony:
        '“Virtual enterprise has provided us with exceptional customer service and Automated Attendant services over the past five years. Without it, my business would not have the same stellar phone customer support. We are truly satisfied.”',
      image: TestimonialThree,
    },
    {
      name: 'E. Kildare',
      testimony:
        '“Virtual Enterprise has allowed my company to easily expand into different markets quickly and without the associated high overhead costs. My clients even commented on the high level of customer service delivered. Thanks Virtual Enterprise!!”',
      image: TestimonialFour,
    },
  ]

  return (
    <div className="testimonial">
      <div className="testimonial__wrapper">
        {testimonials.map(({ name, testimony, image }, index) => (
          <Testimony key={index} name={name} image={image} testimony={testimony} />
        ))}
      </div>
    </div>
  )
}

const Testimony = ({ name, testimony, image }) => {
  return (
    <div className="testimony">
      <p>{name}</p>
      <img src={image} alt="" />
      <p>{testimony}</p>
    </div>
  )
}

export default Testimonial

